import { RouteObject } from 'react-router-dom';
import { PreparePackage } from '../PreparePackage';

export const PreparePackageRoutes: RouteObject[] = [
  {
    path: 'prepare-package',
    element: <PreparePackage />,
  },
];
